import { render, staticRenderFns } from "./ColorPickerDesktop.vue?vue&type=template&id=6c21b5b5&scoped=true&"
import script from "./ColorPickerDesktop.vue?vue&type=script&lang=ts&"
export * from "./ColorPickerDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPickerDesktop.vue?vue&type=style&index=0&id=6c21b5b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c21b5b5",
  null
  
)

export default component.exports